export default __webpack_public_path__ + "static/media/professional_user.bc50225a.svg";